module.exports = __webpack_public_path__ + "img/value-1.3281af7c.svg";